import { render, staticRenderFns } from "./media-details.html?vue&type=template&id=19a7793c&scoped=true&external"
import script from "./media-details.js?vue&type=script&lang=js&external"
export * from "./media-details.js?vue&type=script&lang=js&external"
import style0 from "./media-details.scss?vue&type=style&index=0&id=19a7793c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7793c",
  null
  
)

export default component.exports